import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { DISTRIBUTION_STATUS } from 'shared/constants/distribution';
import { getCombinedDistributionStatus } from 'shared/utils/distribution';
import { Popover, Badge } from 'antd';
import DistributionList from 'components/DistributionList';
import DistributionStatusTag from 'components/DistributionStatusTag';
import DistributionStatusBadge from 'components/DistributionStatusBadge';
import { EDIT_SURVEY } from 'shared/constants/permissions';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';

import globalMessages from 'translations/messages';

const { ACTIVE } = DISTRIBUTION_STATUS;

const QUERY = gql`
  query ($distIds: [ID!]!) {
    distributionStatus(ids: $distIds) {
      id
      status
    }
  }
`;

const SurveyGroupStatusTag = ({ surveyGroup, distributions, linkTo, showPopover, showBadge, showTooltip }) => {
  const distIds = distributions?.map(d => d.id);

  const { data: { distributionStatus = [] } = {}, loading } = useQuery(QUERY, {
    variables: { distIds },
    skip: surveyGroup.status || !distIds?.length || distributions.every(d => d.status),
  });

  const surveyGroupStatus = surveyGroup.status || getCombinedDistributionStatus(distributionStatus?.length ? distributionStatus : distributions);

  if (showBadge) {
    if (surveyGroupStatus === ACTIVE) {
      return <DistributionStatusBadge status={surveyGroupStatus} showTooltip={showTooltip} />;
    }
    return <Badge color="transparent" />;
  }

  let content = <DistributionStatusTag status={surveyGroupStatus} loading={loading} type={surveyGroup.type} showTooltip />;

  if (linkTo) {
    content = (
      <Link permission={EDIT_SURVEY} to={linkTo}>
        {content}
      </Link>
    );
  }

  if (showPopover) {
    const distributionsWithStatus = distributions.map((d) => ({
      ...d,
      ...distributionStatus.find(ds => ds.id === d.id),
    }));

    return (
      <Popover
        title={<FormattedMessage {...globalMessages.distributions} />}
        content={<DistributionList distributions={distributionsWithStatus} />}
        placement="left"
        overlayStyle={{ maxWidth: 650 }}
      >
        {content}
      </Popover>
    );
  }

  return content;
};

export default SurveyGroupStatusTag;
